import * as PIXI from 'pixi.js';
import * as TweenJS from "slotworks/utils/tween";
import Layers from "slotworks/graphics/layers/layers";
import Contract from 'slotworks/utils/contract';
import AnimatedSprite from 'slotworks/graphics/animation/animated-sprite';
import { parallel } from 'slotworks/utils/race-utils';
import currency from 'slotworks/i18n/currency';
import betModel from 'slotworks/model/bets/bet-model';

const MULTIPLIERS = [
    0, 0, 0, 0, 0, 0,
    2, // 6
    4,
    8,
    15,
    20,
    30,
    50,
    100,
    250,
    750
]
export default class QuickHitElement {

    public static FLICKER_TIME = 180;
    public static INITIAL_FLICKER_TIME = 100;

    private neonOuter: PIXI.Sprite;
    private neonInner: PIXI.Sprite;

    private winAnim: AnimatedSprite;
    // private spinAnimation: AnimatedSprite;

    private tween: TweenJS.Tween<{ alpha: number }> = null;

    private value: number;
    private textValue: PIXI.Text;

    private textCount: PIXI.Text;

    private readonly neonLayer: Layers;
    private readonly animLayer: Layers;

    constructor(public readonly num: number) {
        this.neonLayer = Layers.Custom.get("MatrixNeon");
        this.animLayer = Layers.Custom.get("MatrixAnim");

        this.setUp(true);

        this.stop();
    }

    public reset() {
        this.setUp();
    }

    private setUp(init: boolean = false) {
        this.neonInner = this.neonLayer.getSprite(this.num + "_Neon_neon_1");
        this.neonOuter = this.neonLayer.getSprite(this.num + "_Neon_neon_2");

        this.winAnim = this.animLayer.getAnimatedSprite("win" + this.num);
        this.winAnim.loop = true;
        this.winAnim.stop();

        // this.spinAnimation = this.animLayer.getAnimatedSprite("spin" + this.num);
        // this.spinAnimation.loop = true;
        // this.spinAnimation.stop();

        this.textCount = this.neonLayer.getText("quickCount" + this.num);

        this.textValue = this.neonLayer.getText("quickValue" + this.num);

        const value = betModel.getTotalBet() * MULTIPLIERS[this.num];
        this.textValue.text = currency.format(value, undefined, undefined, true);
    }

    public win() {
        this.winAnim.visible = true;
        this.winAnim.play();
    }

    // public startSpin() {
    //     this.spinAnimation.visible = true;
    //     this.spinAnimation.play();
    // }

    // public stopSpin() {
    //     this.spinAnimation.stop();
    // }

    public setTint(tint: number, alpha: number = 1) {
        this.textCount.tint = tint;
        this.textValue.tint = tint;
        this.textCount.alpha = alpha;
        this.textValue.alpha = alpha;
    }

    public resetTint() {
        this.setTint(0xffffff, 1);
    }

    public resetBoosters() {
        this.textCount.text = this.num.toString();
    }

    public flicker(time: number = QuickHitElement.INITIAL_FLICKER_TIME) {
        return new Contract<void>(resolve => {
            this.stop();
            this.win();
            this.winAnim.visible = true;
            this.winAnim.gotoAndPlay(0);

            this.neonInner.visible = true;
            this.neonOuter.visible = true;

            const obj = { alpha: 0 };
            const update = () => {
                this.neonInner.alpha = obj.alpha;
                this.neonOuter.alpha = obj.alpha;
            }
            this.tween = new TweenJS.Tween(obj)
                .to({ alpha: 1 }, time)
                .onUpdate(update)
                .onComplete(() => {
                    update();
                    this.winAnim.stop();
                    this.winAnim.visible = false;
                    resolve(null);
                })
                .repeat(1)
                .yoyo(true)
                .start();
        });
    }

    public endlessFlicker(win: boolean = false) {
        this.stop();
        this.win();

        this.neonInner.visible = true;
        this.neonOuter.visible = true;

        const obj = { alpha: 0 };
        const update = () => {
            this.neonInner.alpha = obj.alpha;
            this.neonOuter.alpha = obj.alpha;
        }
        this.tween = new TweenJS.Tween(obj)
            .to({ alpha: 1 }, QuickHitElement.FLICKER_TIME)
            .onUpdate(update)
            .repeat(Infinity)
            .yoyo(true)
            .start();
    }

    public stop() {
        if (this.tween) {
            this.tween.stop();
            this.tween = null;            
        }
        this.neonInner.visible = false;
            this.neonOuter.visible = false;
            this.neonInner.alpha = 0;
            this.neonOuter.alpha = 0;

        if (this.winAnim.playing) {
            this.winAnim.stop();
            this.winAnim.visible = false;
        }
    }

    public setBoostersInstant(booster: number) {
        this.textCount.text = Math.floor(this.num - booster).toString();
    }

    public setBooster(booster: number, time: number) {
        return parallel([
            () => new Contract<void>(resolve => {
                const obj = { value: this.num };
                this.textCount.scale.set(1.1, 1.1);
                const update = () => {
                    this.textCount.text = Math.floor(obj.value).toString();
                }
                new TweenJS.Tween(obj)
                    .to({ value: this.num - booster }, time)
                    .onUpdate(update)
                    .onComplete(() => {
                        update();
                        this.textCount.scale.set(1, 1);
                        resolve(null);
                    })
                    .start()
            }),
            () => this.flicker(time)
        ])
    }
}